export const REGULATIONS = {
  TOWN_CODE: 'townCode',
  PROCESS_NATURE: 'processNature',
  OPPOSING_LAWYER: 'civilPartyLawyer',
  OPPOSING_LAWYER_CITY: 'civilPartyLawyerCity',
  OPPOSING_LAWYER_ADDRESS: 'civilPartyLawyerAddress',
  OPPOSING_LAWYER_EMAIL: 'civilPartyLawyerEmail',
  JUDGEMENT_DATE: 'judgementDate',
  JUDGEMENT_DATE_JAF: 'judgementDateJom',
  IS_IDD_CHECKED: 'isIDDChecked',
  CALCULATION_START_DATE: 'calculationStartDate',
  REGULATION_DATE: 'settlementDate',
  REGULATION_NATURE: 'natureCode',
  CATEGORY_CODE: 'categoryCode',
  BNEJ_TAX_AMOUNT: 'BNEJTaxAmount',
  DIRECT_INDEMNITY_COSTS: 'directIndemnityCosts',
  COURT_NUMBER: 'courtNumber',
  JUDGEMENT_COURT_NUMBER: 'judgementCourtNumber',
  BENEFICIARY_RECIPIENT: 'beneficiaryRecipient',
  EXPAND: 'expand',
  RC: 'rc',
  OTHER_RECIPIENT: 'otherRecipient', //if selected "others" in beneficiaryRecipient, pass otherRecepient value in beneficiaryRecipient
  PAYMENT_NATURE: 'PaymentNatureCode',
  PAYMENT_STATUS: 'PaymentStatusCode',
  PAYMENT_CHANNEL: 'PaymentChannelCode',
  PAYMENT_METHOD: 'paymentModeCode',
  DEDUCTION_RATE: 'deductionRate',
  DEDUCTION_TYPE: 'deductionType',
  REAL_BENEFICIARY: 'realBeneficiary',
  OTHER_REAL_BENEFICIARY: 'otherRealBeneficiary', //if selected "others" in beneficiaryRecipient, pass the value of otherRealBeneficiary in realBeneficiary
  BENEFICIARY_REFERENCE: 'beneficiaryReference',
  COUNTRY_CODE: 'countryCode',
  ADDITIONAL_ADDRESS: 'complement',
  BNEJ_NUMBER: 'BNEJNumber',
  IS_TOTAL_EXECUTION: 'isTotalExecution',
  APPEAL_COURTS: 'appealCourts',
  TPI: 'TPI',
  STATUS_CODE: 'statutCode',
  LEVEL_REQUIREMENT: 'requirementLevelCode',
  IS_APPEAL: 'isAppeal',
  REFERENCE: 'reference',
  LINK_TO_BENEFICIARY: 'lineOfReciptCode',
  CITY_CODE: 'cityCode',
  JUDGEMENT_AMOUNT: 'judgementAmount',
  APPEAL_AMOUNT: 'arrestAmount',
  VALIDATOR: 'validator',
  STATUS: 'status',
  JUDGEMENT_ID: 'judgementId',
  WITH_CONTESTATION: 'withContestation',
  PROCEDURE_TYPE: 'procedureType',
  ASSIGNED_LAWYER: 'assignedLawyer',
  SHARED_RESPONSABILITY_RATE_WIHTOUT_JUDGEMENT: 'sharedResponsabilityRate',
  ASSIGNED_LAWYER_BASIC_MANAGEMENT: 'assignedLawyerBasicManagement',
  PAYMENT_METHOD_CORPO: 'paymentMethod',
};
export const REGULATION_AMOUNTS = {
  PRINCIPAL_AMOUNT: 'principalAmount',
  DAMAGE_AMOUNT: 'damageAmount',
  APPEAL_DAMAGE_AMOUNT: 'appealDamageAmount',
  COMPENSATION_AMOUNT: 'compensationAmount',
  COMPANY_AMOUNT: 'companyAmount',
  APPEAL_AMOUNT: 'appealAmount',
  RATE: 'executionRate',
  AMOUNT: 'Amount',
  JUDGEMENT_REASON: 'judgementReason',
  JUDGEMENT_AMOUNT: 'judgementAmount',
  APPEAL_REASON: 'appealReason',
  EXECUTION_PROV_AMOUNT: 'manualExecutionProvAmount',
  MEDICAL_FEES: 'medicalFees',
  FUNERAL_FEES: 'funeralFees',
  MEDICAL_FEES_REASON: 'medicalFeesReason',
  FUNERAL_FEES_REASON: 'funeralFeesReason',
  RESPONSIBILITY_SHARE: 'responsibilityShare',
};
export const PROVISION = {
  VICTIM_AMOUNT: 'provisionAmount',
  REASON: 'provisionReason',
  CONTRIBUTOR_AMOUNT: 'contributorAmount',
  CONTRIBUTOR_CODE: 'contributorCode',
  CONTRIBUTOR_TYPE_CODE: 'contributorTypeCode',
  RISK_ID: 'riskID',
};
export const EMPTY_REGULATION_INFO = {
  [REGULATIONS.TOWN_CODE]: '',
  [REGULATIONS.PROCESS_NATURE]: null,
  [REGULATIONS.OPPOSING_LAWYER]: '',
  [REGULATIONS.OPPOSING_LAWYER_ADDRESS]: '',
  [REGULATIONS.OPPOSING_LAWYER_EMAIL]: '',
  [REGULATIONS.JUDGEMENT_DATE]: null,
  [REGULATIONS.JUDGEMENT_DATE_JAF]: null,
  [REGULATIONS.CALCULATION_START_DATE]: null,
  [REGULATIONS.EXPAND]: true,
  [REGULATIONS.IS_IDD_CHECKED]: '',
  [REGULATIONS.REGULATION_DATE]: null,
  [REGULATIONS.CATEGORY_CODE]: '82', //décision judiciaire
  [REGULATIONS.BNEJ_TAX_AMOUNT]: null,
  [REGULATIONS.DIRECT_INDEMNITY_COSTS]: 0,
  [REGULATIONS.COURT_NUMBER]: '',
  [REGULATIONS.DEDUCTION_TYPE]: 'P',
  [REGULATIONS.REAL_BENEFICIARY]: '',
  [REGULATIONS.REGULATION_NATURE]: '',
  [REGULATIONS.REFERENCE]: '',
};
export const PAYMENT_STATUS = {
  REJECTED: 'Rejeté',
  CANCELED: 'Annulé',
};
